import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,html [type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[hidden]{display:none}

* { -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; }

.sr-only { position: absolute; width: 1px; height: 1px; margin: -1px; border: 0; padding: 0; white-space: nowrap; clip-path: inset(100%); clip: rect(0 0 0 0); overflow: hidden;}

:root {
  --white:#FCFCFC;
  --red: #EF476F;
  --blue:#39A0ED;
  --green:#06D6A0;
  --yellow:#FFD166;
  --orange:#FC7A57;
  --purple: #63458A;
  --black:#000000;
}

button {
  cursor: pointer;
}


html {
  font-size:62.5%;
  font-family:'Poppins', sans-serif;
  font-weight:400;
  background-color:#FCFCFC;
  overscroll-behavior:none;
  overflow-x:hidden !important;
  &.lenis {
    height: auto;
  }
}

body {
  min-height:100vh;
  min-width:100vw;
  -webkit-overscroll-behavior: none;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
}


.container {
  position:relative;
}

.lenis.lenis-smooth {
  scroll-behavior: auto;
}

ul {
  list-style:none;
}

footer {
  text-align:center;
  p {
    font-weight:500;
  }
  a:hover {
    font-weight:900;
  }
}


.wrapper {
  width:1400px;
  max-width:90%;
  margin:0 auto;
}

section {
 min-height:100vh;
 overflow-y: auto;
 padding:50px 0;
 &#siteIntro{
  padding:35px 0;
 }
 
}
.background {
  margin:0 auto;
  z-index:-1;
  position:fixed;
  width:100vw;
  height:100vh;
}

.siteIntro {
  background:var(--white);
  border:solid 1.5rem var(--blue);
  border-radius:0.5rem;
  box-shadow:0.5rem 0.5rem 0.8rem var(--blue);
  padding:2rem 3rem;
  p {
    margin:3.2rem 0;
    @media screen and (max-width:600px){
      margin:2.5rem 0;
    }
  }
}
.moreLinks {
    max-width:500px;
    margin:5rem auto;
    background:var(--white);
    border:solid var(--black) 0.75rem;
    border-radius:1.5rem;
    padding:1.25rem;
    p {
        text-align:center;
        font-weight:700;
        font-size:clamp(2rem, 2.4vw, 2.7rem);
        margin:2.5rem 0;
      }
      .ctaFlex {
        display:flex;
        flex-wrap:wrap;
        gap:1rem;
        justify-content:center;
      }
    }


.serviceGrid {
  padding:50px 0;
  display:flex;
  height:auto;
  flex-wrap:wrap;
  justify-content:center;
  column-gap: 4rem;
  row-gap:8rem;
}

#contact {
  margin-top:50px;
  margin-bottom:-50px;
}

.staffGrid {
  padding:25px;
  display:flex;
  flex-wrap:wrap;
  gap:2.5rem;
  align-items:flex-start;
  justify-content:space-evenly;
  .staffCard {
    flex: 2 1 auto;
    box-shadow:4px 4px 3px var(--black);
    max-width:250px;
    border-radius:5px;
    display:flex;
    flex-direction:column;
    position:relative;

    &:hover .buttonOverlay,
    &:focus-within .buttonOverlay {
      background:#06D6A0A5;
    }
    &:hover .buttonOverlay,
    &:focus-within .buttonOverlay {
      opacity:1;
    }
  }

  .gatsby-image-wrapper {
    border:solid 0.5rem var(--green);
  }
  .staffInfo {
    max-width:100%;
    background:var(--white);
    p {
      margin:0;
      padding:4px;
      line-height:1.1em;
    }
  }
}


.buttonOverlay {
    position: absolute;
    width:100%;
    height:100%;
    border:none;
    overflow:hidden;
    color:var(--white);
    cursor: pointer;
    text-align:center;
    font-size:2rem;
    &:hover,
    &:focus {
      text-decoration:underline;
    }
  }

  .buttonOverlay,
  .buttonOverlay .cta {
    opacity:0;
  }

.ReactModal__Html--open,
.ReactModal__Body--open {
  overflow: hidden; /* prevents background page from scrolling when the modal is open */
}

.staffModal {
  .flexContent {
    display:flex;
    flex-wrap:wrap;
    gap:2.5rem;
    align-items:center;
    justify-content:center;
  }

  .gatsby-image-wrapper {
    flex: 0 1 auto;
  }

  .textContent {
    flex: 2 1 300px;
  }
  .ReactModal__Container::-webkit-scrollbar {
    width:10px;
    background:var(--red);
  }
}

.modalClose {
    background: none;
    border: none;
    position: absolute;
    top: 15px;
    right: 25px;
    font-size: 2rem;
    &:hover svg,
    &:focus svg {
      filter:drop-shadow(1px 1px 3px var(--black));
    }
}

.linksModal {
  overflow:scroll;
  h3 {
    color:var(--blue);
    text-align:center;
  }
  .linksList {
    padding:0;
    margin:0;
  }
  li {
    margin:0.25rem 0;
    padding:0.5rem 0;
  }
  a {
    font-size:clamp(1.6rem, 2.4vw, 2.1rem);
    font-weight:600;
    text-decoration:underline;
    &:hover,
    &:focus,
    &:active {
      color:var(--blue);
    }
  }
}

.phoneModal {
  .phoneList {
    padding-left:0;
  }
  h3 {
    color:var(--purple);
  }
  li {
    h4 {
      font-size:clamp(1.6rem, 2.4vw, 2.1rem);
    }
    a {
      font-size:clamp(1.4rem, 2.4vw, 2rem);
      &:hover,
      &:focus,
      &:active {
        color:var(--purple);
        font-weight:600;
      }
    }
  }
}

.postGallery {
  display:flex;
  gap:2.5rem;
  .postCard {
    background:var(--orange);
    border: solid 0.5rem var(--black);
    box-shadow:0.5rem 0.5rem var(--green);
    color:var(--white);
    font-weight:600;
    padding:15px;
  }
}

.toTop {
  position:fixed;
  bottom:15px;
  right:5px;
  z-index:50;
  transition: opacity ease-in-out 0.3s;
  button {
    border:none;
    padding:0;
    background:none;
    font-size:2.4rem;
  }
  &:hover {
    button {
      filter: drop-shadow(1px 1px var(--black));
    }
  }
}

.footerContainer {
  background:var(--white);
  margin:1.5rem auto;
  border:solid 0.5rem var(--black);
  border-radius:2rem;
  padding:1.5rem;
}

.modalContentFlex {
  display:flex;
  flex: 2 1 auto;
  gap: 1.2rem;
  @media screen and (max-width:500px) {
    flex-direction:column;
  }
}

.hoverable {
  font-weight:600;
  text-decoration:underline;
  &:hover,
  &:focus,
  &:active {
    color:var(--blue);
  }
}
`

export default GlobalStyles